import React from "react";
import Container from "./Container";
import styled, { css } from "styled-components";
import { convertToRelativePath } from '../utils/convertToRelativePath';
import SafeSiteLink from './SafeSiteLink';
import { HtmlContent } from "./Content";

const BreadCrumbStyles = styled.div`
  ${({ ...props }) => css`
    position: relative;
    z-index: 97;
    background-color: ${props.theme.colors.primary};
    @media (max-width: 767px) {
      padding: 2px 0;
      ol {
        display: none;
      }
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      display: block;
      padding: 16px 0;
      color: #fff;

      ol {
        display: flex;

        li {
          &:after {
            content: "/";
            display: inline-block;
            margin: 0 8px;
            font-weight: 400;
          }

          &:last-child:after {
            display: none;
          }

          span {
            opacity: 0.5;
          }

          a:hover {
            color: #fff;
          }
        }
      }
    }
  `}
`;

export const Breadcrumbs = ({ breadcrumbs }) => {
  breadcrumbs.forEach(breadcrumb => {
    if (breadcrumb.item?.url) {
      breadcrumb = breadcrumb.item
    }
    if (breadcrumb.text) {
      breadcrumb.name = breadcrumb.text
    }
    breadcrumb.url = convertToRelativePath(breadcrumb.url)
  })

  return (
    <BreadCrumbStyles className="cat-bg">
      <Container>
        <nav aria-label="Breadcrumb">
          <ol>
            {breadcrumbs.map((breadcrumb, index, arr) => {
              return (
                breadcrumb.url &&
                <li key={breadcrumb.url}>
                  {arr.length - 1 === index ? (
                    <span><HtmlContent htmlString={breadcrumb.text} /></span>
                  ) : (
                    <SafeSiteLink url={breadcrumb.url} text={breadcrumb.text} />
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </Container>
    </BreadCrumbStyles>
  );
};
